import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FlexContainer, FlexItem } from '../../styled/layout.styled';
import { Caption } from '../../styled/typograpghy.styled';
import Button from '../reusable/Button';

const StyledCaption = styled(Caption)`
  margin-bottom: 32px;
`;

const StyledSpan = styled.span`
  color: #ffffff;
`;

const CampaignDeleteModalContent = ({ onCancel, onDelete }) => (
  <>
    <FlexContainer margin="32px 0 0 0" flexWrap tabletFlexWrap mobileFlexWrap justifyContent="space-between">
      <FlexItem width="100%">
        <StyledCaption>
          You will permanently lose your <StyledSpan className="bold">campaign url</StyledSpan> and{' '}
          <StyledSpan className="bold">campaign history</StyledSpan>.
        </StyledCaption>
      </FlexItem>
      <FlexItem width="48%">
        <Button onClick={() => onCancel()} buttonShape="bordered">
          Cancel
        </Button>
      </FlexItem>
      <FlexItem width="48%">
        <Button onClick={() => onDelete()}>Delete</Button>
      </FlexItem>
    </FlexContainer>
  </>
);

CampaignDeleteModalContent.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CampaignDeleteModalContent;
